export default function GetAppBanner() {
    return (
        <section id="getApp">
            <img className="w-[100%] h-auto my-10" src="https://media-assets.swiggy.com/swiggy/image/upload/fl_lossy,f_auto,q_auto/portal/m/seo/App_download_banner.png" alt="banner" />
        </section>
    )
};